module.exports = __webpack_public_path__ + "img/ep-lune.1d639c7e.jpg";